import { EmotionIcon } from '@emotion-icons/emotion-icon'
import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { PropsWithChildren } from 'react'
import { Spinner } from 'src/components/spinner'
import { Colors } from 'src/components/theme'

const ChipBase = styled.div`
  border-radius: 100px;
  background-color: #fff;
  width: fit-content;
`
const ChipContainer = styled.div<{ color: string }>`
  cursor: default;
  padding: 2px 6px;
  border-radius: 100px;
  background-color: ${({ color }) => color};
  width: fit-content;
`

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

const Dot = styled.div<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
`

const Text = styled(Typography)`
  flex: 1;
`

export type ChipProps = {
  backgroundColor?: string
  iconColor?: string
  icon?: EmotionIcon | false
  iconSize?: number
  loading?: boolean
  maxWidth?: number
}

export const Chip = ({
  backgroundColor = Colors.bgLightGrey,
  iconColor = Colors.buttonGrayText,
  icon: Icon,
  iconSize = 8,
  loading = false,
  children,
  maxWidth,
}: PropsWithChildren<ChipProps>) => {
  return (
    <ChipBase>
      <ChipContainer color={backgroundColor} style={{ maxWidth }}>
        <ContentWrapper>
          {!loading && Icon === undefined && <Dot color={iconColor} />}
          {!loading && Icon && <Icon size={iconSize} color={iconColor} />}
          {loading && <Spinner size={12} />}
          {typeof children === 'string' ? (
            <Text variant="text1m" noWrap>
              {loading ? 'Loading...' : children}
            </Text>
          ) : (
            children
          )}
        </ContentWrapper>
      </ChipContainer>
    </ChipBase>
  )
}

export const ChipLoading = () => <Chip loading />
